import { GEOS } from './constants.ts';
import type { GeoRegion } from './v2-resource';

const PRODUCTS_AVAILABILITY_BY_REGION = {
  us: [
    'boundary',
    'consul',
    'packer',
    'terraform',
    'vagrant',
    'vault',
    'vault-radar',
    'vault-secrets',
    'waypoint',
  ] as const,
  eu: ['terraform', 'waypoint'],
};

export type ProductName = (typeof PRODUCTS_AVAILABILITY_BY_REGION.us)[number];

export const checkReleaseAvailability = (
  product: ProductName,
  deployGeo: GeoRegion = GEOS.US
) => {
  return PRODUCTS_AVAILABILITY_BY_REGION[deployGeo].includes(product);
};
